import React from 'react';

import styles from './index.module.scss';

const VolumeMutedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden
  >
    <path
      d="M7.5 6.89043H6.60938C6.04222 6.89043 5.75865 6.89043 5.52948 6.96614C5.07848 7.11513 4.7247 7.46892 4.57571 7.91991C4.5 8.14908 4.5 8.43266 4.5 8.99981C4.5 9.56696 4.5 9.85054 4.57571 10.0797C4.7247 10.5307 5.07848 10.8845 5.52948 11.0335C5.75865 11.1092 6.04222 11.1092 6.60938 11.1092H7.67687C7.88739 11.1092 7.99265 11.1092 8.08992 11.1358C8.1761 11.1594 8.25737 11.1982 8.32989 11.2504C8.41175 11.3093 8.47791 11.3912 8.61022 11.555L9.86665 13.1098C10.5216 13.9203 10.8491 14.3256 11.136 14.3697C11.3844 14.4079 11.6354 14.3191 11.8046 14.1333C12 13.9187 12 13.3976 12 12.3556V11.2498M12 7.87481V5.23301C12 4.53079 12 4.17968 11.9082 4.0116C11.7247 3.67581 11.3179 3.53198 10.9641 3.67784C10.787 3.75085 10.5664 4.02394 10.125 4.57012L9.65625 5.1502M4.5 3.74981L15 14.2498"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VolumeOnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    aria-hidden
  >
    <path
      d="M12.5242 0.75C13.2236 1.38905 13.7819 2.16173 14.1648 3.02038C14.5476 3.87903 14.7469 4.80543 14.7502 5.74245C14.7535 6.67946 14.5609 7.60721 14.1842 8.46846C13.8075 9.3297 13.2547 10.1062 12.5599 10.75M10.6146 2.75656C11.0343 3.13998 11.3693 3.60359 11.599 4.11878C11.8287 4.63397 11.9482 5.18982 11.9502 5.75202C11.9522 6.31423 11.8366 6.87088 11.6106 7.38763C11.3846 7.90438 11.0529 8.37027 10.636 8.75656M4.58645 8.10318L5.75912 9.52513C6.37042 10.2664 6.67608 10.637 6.94386 10.6774C7.17568 10.7123 7.40994 10.6311 7.56784 10.4612C7.75024 10.2649 7.75024 9.78839 7.75024 8.83536V2.69742C7.75024 1.74439 7.75024 1.26788 7.56784 1.07158C7.40994 0.901644 7.17568 0.820491 6.94386 0.855417C6.67608 0.895763 6.37042 1.26639 5.75912 2.00765L4.58645 3.4296C4.46296 3.57935 4.40121 3.65422 4.32481 3.7081C4.25712 3.75583 4.18127 3.79133 4.10084 3.81292C4.01005 3.83728 3.91181 3.83728 3.71532 3.83728H2.71899C2.18965 3.83728 1.92498 3.83728 1.71109 3.90652C1.29016 4.04278 0.959961 4.36633 0.820905 4.77878C0.750244 4.98837 0.750244 5.24771 0.750244 5.76639C0.750244 6.28507 0.750244 6.54441 0.820905 6.754C0.959961 7.16645 1.29016 7.49 1.71109 7.62626C1.92498 7.6955 2.18965 7.6955 2.71899 7.6955H3.71532C3.91181 7.6955 4.01005 7.6955 4.10084 7.71986C4.18127 7.74145 4.25712 7.77695 4.32481 7.82468C4.40121 7.87856 4.46296 7.95343 4.58645 8.10318Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export interface VideoControlBarProps {
  isPlaying: boolean;
  isMuted: boolean;
  togglePlay: () => void;
  toggleMute: () => void;
  formatTime: (seconds: number) => string;
  currentTime: number;
  duration: number;
  progress: number;
  progressBarRef: React.RefObject<HTMLDivElement>;
  handleProgressClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  handleProgressMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
}

/** 全屏播放器与内嵌预览共用：音量 + 播放 + 进度 */
export const VideoControlBar: React.FC<VideoControlBarProps> = ({
  isPlaying,
  isMuted,
  togglePlay,
  toggleMute,
  formatTime,
  currentTime,
  duration,
  progress,
  progressBarRef,
  handleProgressClick,
  handleProgressMouseDown,
}) => (
  <div className={styles.controls}>
    <div
      className={styles.volumeButton}
      data-testid="video-volume-button"
      onClick={(e) => {
        e.stopPropagation();
        toggleMute();
      }}
    >
      {isMuted ? <VolumeMutedIcon /> : <VolumeOnIcon />}
    </div>

    <div
      className={styles.playButton}
      data-testid="video-play-button"
      onClick={(e) => {
        e.stopPropagation();
        togglePlay();
      }}
    >
      {isPlaying ? (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" aria-hidden>
          <rect x="8" y="6" width="3" height="14" rx="1" fill="white" />
          <rect x="15" y="6" width="3" height="14" rx="1" fill="white" />
        </svg>
      ) : (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" aria-hidden>
          <path d="M9 6L20 13L9 20V6Z" fill="white" stroke="white" strokeWidth="1" />
        </svg>
      )}
    </div>

    <div className={styles.progressContainer}>
      <span className={styles.time} style={{ letterSpacing: '0.5px' }}>
        {formatTime(currentTime)}
      </span>
      <div
        ref={progressBarRef}
        className={styles.progressBar}
        onClick={(e) => {
          e.stopPropagation();
          handleProgressClick(e);
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
          handleProgressMouseDown(e);
        }}
      >
        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>
      </div>
      <span className={styles.time} style={{ letterSpacing: '0.5px' }}>
        {formatTime(duration)}
      </span>
    </div>
  </div>
);
